const API_BASE = process.env.REACT_APP_API_URL;

export const API_EmailCodeforPortalLogin = (email) => `${API_BASE}login?email=${email}`;
export const API_PortlLogin = () => `${API_BASE}validate_login`;
export const API_AppLogin = () => `${API_BASE}validate_direct_login`;
export const API_GetFeatures = (device_id) => `${API_BASE}get_features/${device_id}`;
export const API_CreatePaymentSession = () => `${API_BASE}create_payment_session`;
export const API_CreateCustomerSession = (device_id) => `${API_BASE}create_customer_session/${device_id}`;
export const API_CheckPaymentStatus = () => `${API_BASE}check_payment_status`; 